import { Link } from '~/components/Link'
import { BootcampModuleCard } from '~/bootcamp/types/bootcamp.types'
import StripeProgressBar from '~/bootcamp/components/StripeProgressBar/StripeProgressBar'
import { checkTagValidity } from '~/bootcamp/utils/bootcamp.utils'
import ResponsiveImage from '~/components/Image/ResponsiveImage'
import BootcampStatusTag from '~/bootcamp/components/BootcampStatusTag'
import { AppLanguage } from '~/types/locale'
import TitleWithEnLabel from '~/bootcamp/components/TitleWithEnLabel'
import { TopicId } from '~/dashboard/utils/learningPath.utils'
import { getLongestWordLength } from '~/utils'

import PrerequisitesCollapse from './PrerequisitesCollapse'

const BootcampCard = (props: BootcampModuleCard): React.ReactElement => {
  const {
    name,
    path,
    progress,
    prerequisites,
    moduleColor,
    secondaryColor,
    tagStatus,
    topicsIconData,
    isSubjectUpcoming,
    isUpcoming,
    onClick,
    taskReferences,
  } = props
  const isTagValid = tagStatus?.tag && checkTagValidity(tagStatus?.validity)
  const wrapperClassName = isTagValid ? 'mt-4' : ''
  const locale = isUpcoming || isSubjectUpcoming ? AppLanguage.EN : undefined
  const isAlgebra = topicsIconData?.key === TopicId.ALGEBRA
  const mathPreview = taskReferences?.mathPreview?.srcKey || 'icons/h.png'
  const isNameLarge = getLongestWordLength(name ?? '') > 17
  return (
    <div className={wrapperClassName} data-testid="bootcamp-card" onClick={onClick}>
      <Link
        className={`rounded flex flex-col gap-4 justify-between px-1.5 sm:px-3 py-3 shadow-large relative ${moduleColor}`}
        locale={locale}
        to={path}
      >
        {isTagValid && <BootcampStatusTag className="absolute z-40 -top-4" status={tagStatus?.tag} />}
        <div className="flex justify-between items-center gap-1 sm:gap-1 w-full min-h-14">
          {topicsIconData && (
            <ResponsiveImage
              alt={topicsIconData?.iconAlt || ''}
              className={`absolute opacity-20 ml-5 rotate-9 ${isAlgebra ? 'mt-0' : 'mt-1'}`}
              fit="contain"
              height={isAlgebra ? 90 : 75}
              imageWidths="100"
              srcKey={topicsIconData?.iconKey}
              width={100}
            />
          )}
          <div className={`flex ${isNameLarge ? 'text-xs' : 'text-base'} text-white text-center z-10 m-auto`}>
            <TitleWithEnLabel className="text-white" isNameLarge={isNameLarge} isUpcoming={isUpcoming} name={name} />
          </div>

          <div className="flex min-w-30 justify-center border border-white rounded-small">
            <ResponsiveImage
              fit="contain"
              height={55}
              imageClassName="p-1"
              imageWidths="120"
              srcKey={mathPreview}
              width={120}
            />
          </div>
        </div>
        <div className="bg-white rounded">
          <StripeProgressBar percentage={progress || 0} progressColorClass="bg-task-proofs-gradient" />
        </div>
      </Link>
      <PrerequisitesCollapse className={secondaryColor} items={prerequisites || []} title={name || ''} />
    </div>
  )
}

export default BootcampCard
